import { createAction, props } from '@ngrx/store';
import { SearchConfig } from '@spartacus/core';
import { BranchesList, BranchForm, StoreLocatorFeatureGroup } from '../uig-branches/uig-branches.models';

export const getUigBranchesOverview = createAction(
    '[Uig Branches] get uig branches overview',
    props<{ params: SearchConfig }>()
);

export const getUigBranchesOverviewSuccess = createAction(
    '[Uig Branches] get uig branches overview success',
    props<{ uigBranchesOverview: BranchesList }>()
);

export const getUigBranchesOverviewFailure = createAction(
    '[Uig Branches] get uig branches overview failure',
    props<{ error: Error }>()
);

export const getUigBranchDetails = createAction(
    '[Uig Branches] get uig branch details',
    props<{ name: string }>()
);

export const getUigBranchDetailsSuccess = createAction(
    '[Uig Branches] get uig branch details success',
    props<{ branch: BranchForm }>()
);

export const getUigBranchDetailsFailure = createAction(
    '[Uig Branches] get uig branch details failure',
    props<{ error: Error }>()
);

export const deleteBranch = createAction(
    '[Uig Branches] delete branch',
    props<{ name: string }>()
);

export const deleteBranchSuccess = createAction(
    '[Uig Branches] delete branch success'
);

export const deleteBranchFailure = createAction(
    '[Uig Branches] delete branch failure'
);


export const deleteBranchReset = createAction(
    '[Uig Branches] delete branch reset'
);

export const createOrUpdateBranch = createAction(
    '[Uig Branches] create or update branch',
    props<{ branch: BranchForm }>()
);

export const createOrUpdateBranchSuccess = createAction(
    '[Uig Branches] create or update branch success'
);

export const createOrUpdateBranchFailure = createAction(
    '[Uig Branches] create or update branch failure'
);

export const createOrUpdateBranchReset = createAction(
    '[Uig Branches] create branch reset'
);

export const getUigStoreFeatureGroups = createAction(
    '[Uig Branches] get uig store feature groups'
);

export const getUigStoreFeatureGroupsSuccess = createAction(
    '[Uig Branches] get uig store feature groups success',
    props<{ featureGroups: StoreLocatorFeatureGroup[] }>()
);

export const getUigStoreFeatureGroupsFailure = createAction(
    '[Uig Branches] get uig store feature groups failure',
    props<{ error: Error }>()
);